"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratorSymbol = void 0;
var DecoratorSymbol;
(function (DecoratorSymbol) {
    DecoratorSymbol["RAW_VALUE"] = "__RAW_VALUE__";
})(DecoratorSymbol = exports.DecoratorSymbol || (exports.DecoratorSymbol = {}));
//# sourceMappingURL=DecoratorSymbol.js.map